import { useHistory, useLocation } from 'quartz-routing/react-router';
import { useCallback } from 'react';
import { Screens } from '../../types/PublicNavItem';
import { TRACKING_SOURCES, trackTermSelectorInteraction } from '../../utils/tracking';
import { withFscTerm } from './fscUrlCart';
export function useFscTermToggle({
  purchaseOptions,
  term,
  productApiName
}) {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const isAnnual = term === 'ANNUAL';
  const onToggle = useCallback(() => {
    const nextTerm = isAnnual ? 'MONTHLY' : 'ANNUAL';
    const nextOption = purchaseOptions[nextTerm];
    if (!nextOption) return;
    trackTermSelectorInteraction({
      action: 'click',
      term: nextTerm,
      trackingSource: TRACKING_SOURCES.FSC_CONFIGURE,
      screen: Screens.FSC_CONFIGURE,
      productNames: [productApiName]
    });
    history.replace({
      search: withFscTerm(search, nextOption)
    });
  }, [history, isAnnual, productApiName, purchaseOptions, search]);
  return {
    show: Boolean(purchaseOptions.ANNUAL && purchaseOptions.MONTHLY),
    isAnnual,
    onToggle
  };
}